import { useMemo } from "react";
import { AgGridReact } from "@jsq/ds/core";

export const useWorkspacesTableAgGridOptions = () => {
  const colDefs: AgGridReact.AgGridReactProps["columnDefs"] = useMemo(() => {
    return [
      {
        field: "id",
        headerName: "Arena ID",
        width: 80,
        filter: "agNumberColumnFilter",
        checkboxSelection: true,
        headerCheckboxSelection: true,
      },
      {
        field: "name",
        headerName: "Workspace name",
        sortable: true,
        filter: "agTextColumnFilter",
      },
      {
        field: "jsqHostname",
        headerName: "Domain",
        sortable: false,
      },
      {
        field: "assignedUsersCount",
        headerName: "Assigned users",
        sortable: false,
        width: 80,
      },
      {
        field: "lastAccessTimestamp",
        headerName: "Last access",
        sortable: false,
      },
    ];
  }, []);

  return { colDefs };
};
